import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ContextsContextsService } from 'src/app/services/contexts-services/contexts-contexts-services/contexts-contexts.service';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { Subscription } from 'rxjs/internal/Subscription';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-contexts-contexts-resume-card',
  templateUrl: './contexts-contexts-resume-card.component.html',
  styleUrls: ['./contexts-contexts-resume-card.component.scss']
})
export class ContextsContextsResumeCardComponent implements OnInit, OnDestroy {

  @Input() context;
  @Input() viewDisposition;
  updateContextStatusSubscription: Subscription;
  deleteContextSubscription: Subscription;

  constructor(private snackbarService: SnackBarService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private contextsService: ContextsContextsService,
    public dialog: MatDialog) { }

  ngOnInit() {
  }

  public toggleStatus() {
    this.updateContextStatusSubscription = this.contextsService.updateContextStatus(this.context.InternalId).pipe(
      tap(o => this.context.Active = o['data']['status']),
      tap(o => this.snackbarService.open(o['data']['message'], 'success')),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['../context', this.context.InternalId], { relativeTo: this.activatedRoute.parent });
    }
  }

  public deleteContext() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['context-page.delete context', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteContextSubscription = this.contextsService.deleteContext(this.context.InternalId).pipe(
          tap(o => this.contextsService.refreshContexts()),
          catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
        ).subscribe();
      }
    });
  }

  ngOnDestroy() {
    if (this.deleteContextSubscription) { this.deleteContextSubscription.unsubscribe(); }
  }
}
